<template>
	<h1><span class="val col1">{{ args.amplitude }}</span> · sin(<span class="val col2">{{ args.frequency }}</span>t + <span class="val col3">{{ args.phase }}</span>)</h1>
</template>

<script>
export default {
	props: {
		args: Object,
	},
}
</script>

<style scoped>

h1 {
	font-family: var(--math);
	margin: 40px 5px;
	color: var(--col0);
}

.val {
	font-family: var(--math-b);
	font-size: 22px;
}

</style>
